export const downloadFile = (file: Blob, filename: string) => {
  const url = window.URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  link.click();
  link.remove();
};
